import { useState, useRef } from 'react';

export function useCommentState() {
  const [containerComments, setContainerComments] = useState({});
  const [expandedCommentKey, setExpandedCommentKey] = useState(null);
  const [commentTextFor, setCommentTextFor] = useState(null);
  const [commentTextDraft, setCommentTextDraft] = useState('');
  // eslint-disable-next-line no-unused-vars -- setter kept for possible future use, commentRecordingFor is read in UI
  const [commentRecordingFor, setCommentRecordingFor] = useState(null);
  const [commentUploading, setCommentUploading] = useState(false);
  const mediaRecorderRef = useRef(null);

  return {
    containerComments, setContainerComments,
    expandedCommentKey, setExpandedCommentKey,
    commentTextFor, setCommentTextFor,
    commentTextDraft, setCommentTextDraft,
    commentRecordingFor, setCommentRecordingFor,
    commentUploading, setCommentUploading,
    mediaRecorderRef,
  };
}
